import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { editPath } from "@/lib/sacred-library/utils/registry";

const TYPES = [
  { value: "deity", label: "Deity" },
  { value: "festival", label: "Festival" },
  { value: "vrata", label: "Vrata" },
  { value: "story", label: "Story" },
  { value: "sadhana", label: "Sādhana" },
];

function slugify(text) {
  return text
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_|_$/g, "");
}

export function SacredCreateTopic({ open, onClose }) {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const show = open ?? searchParams.get("create") === "1";
  const [type, setType] = useState("deity");
  const [id, setId] = useState("");
  const [display, setDisplay] = useState("");

  if (!show) return null;

  const go = () => {
    const topicId = slugify(id || display);
    if (!topicId) return;
    onClose?.();
    setSearchParams({});
    navigate(editPath(type, topicId));
  };

  const close = () => {
    onClose?.();
    setSearchParams({});
  };

  return (
    <Card className="mb-8 border-primary/30 shadow-md" data-testid="sacred-create-topic">
      <CardHeader>
        <CardTitle className="text-lg">Add new library topic</CardTitle>
        <p className="text-sm text-muted-foreground">
          Creates a new entry in the cloud library (publish from the editor). Use lowercase id with underscores, e.g.{" "}
          <code className="text-xs">hanuman_jayanti</code>.
        </p>
      </CardHeader>
      <CardContent className="grid sm:grid-cols-2 gap-4">
        <div>
          <Label>Type</Label>
          <select
            className="w-full h-10 border rounded-md px-2 mt-1 text-sm"
            value={type}
            onChange={(e) => setType(e.target.value)}
          >
            {TYPES.map((t) => (
              <option key={t.value} value={t.value}>
                {t.label}
              </option>
            ))}
          </select>
        </div>
        <div>
          <Label>Topic id (URL slug)</Label>
          <Input
            className="mt-1"
            placeholder="e.g. surya_namaskar"
            value={id}
            onChange={(e) => setId(e.target.value)}
          />
        </div>
        <div className="sm:col-span-2">
          <Label>Display name (optional — fills id if empty)</Label>
          <Input
            className="mt-1"
            placeholder="e.g. Sūrya Namaskār"
            value={display}
            onChange={(e) => setDisplay(e.target.value)}
          />
        </div>
        <div className="sm:col-span-2 flex gap-2">
          <Button type="button" onClick={go}>
            Open full editor
          </Button>
          <Button type="button" variant="outline" onClick={close}>
            Cancel
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
